import { render } from "./CustomerMainList.vue?vue&type=template&id=3d89b2ba"
import script from "./CustomerMainList.vue?vue&type=script&lang=js"
export * from "./CustomerMainList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__